import EditPage from "./EditPage";
import NewPage from "./NewPage";
import ShowPage from "./ShowPage";

export const Plans = {
  Show: ShowPage,
  Create: NewPage,
  Edit: EditPage,
};
